module.exports = __webpack_public_path__ + "static/img/organization-bg.a43bdb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organization-bg.jpg
// module id = n2vS
// module chunks = 1